webpackJsonp([16],{

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    console.log(this.$route.params);
  },
  mounted: function mounted() {
    if (this.$route.params && this.$route.params.id === 'About') {
      __WEBPACK_IMPORTED_MODULE_0__main__["EventBus"].$emit("AboutPopup");
    }
  }
});

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(505);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("744ff55f", content, true, {});

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".body{margin:0 10%}.center{text-align:center}.tcTitle{font-weight:400}.sdgTitle{font-size:45px}.titleBold{font-weight:700}ul{list-style:none;padding-left:0}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/PrivacyPolicy/PrivacyPolicy.vue"],"names":[],"mappings":"AACA,MACI,YAAc,CACjB,AACD,QACI,iBAAmB,CACtB,AACD,SACI,eAAmB,CACtB,AACD,UACI,cAAgB,CACnB,AACD,WACI,eAAkB,CACrB,AACD,GACI,gBAAiB,AACjB,cAAgB,CACnB","file":"PrivacyPolicy.vue","sourcesContent":["\n.body {\n    margin: 0 10%;\n}\n.center {\n    text-align: center;\n}\n.tcTitle{\n    font-weight:normal;\n}\n.sdgTitle{\n    font-size: 45px;\n}\n.titleBold{\n    font-weight: bold;\n}\nul {\n    list-style: none;\n    padding-left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('h1',{staticClass:"tcTitle center"},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('h1',{staticClass:"sdgTitle center"},[_vm._v("SDG")]),_vm._v(" "),_c('p',[_vm._v("\n          This Privacy Notice (“Notice”) explains how Soli Deo Gloria Releasing, LLC (“SDG”) collects, uses and discloses information about SDG clients and others who visit SDG websites. The terms “we”, “us” and “our” refer to SDG and its affiliates, which collectively own and operate a transactional video (TVOD) direct digital download platform, as well as any other services that are available from SDG now or in the future (collectively “Services”). The term “you” refers to you as a buyer or user of our Services, including the aforementioned TVOD purchases and downloads, software or mobile applications. Your use of our services constitutes your acceptance of this Notice.\n      ")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n          Collection and Use of Your Personal Information\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          We collect and maintain regular business records containing information about you which may constitute Personally Identifiable Information (“PII”), including but not limited to your name, billing address, email address, phone number, credit card number, and other account information. You are not required to provide the personal information, but if you elect not to do so, it is likely that we will not be able to provide you with the products or services we have to offer. The personal information we collect will allow us to keep you posted of additional products and services which may become available.  \n      ")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n          Third Party Information; Third-Party Services and Websites\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          We may receive information about you from third parties, such as business partners and data companies. You many also access third party products, services, applications or websites  through SDG. If you elect to share information with such third party/ies, please be aware that disclosure of such information will be subject to that third party/ies’ privacy policies, which may differ from ours. We are not responsible for the practices of such third party/ies.\n      ")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n          Cookies and Other Technologies \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          Our Services may be provided through internet websites and/or other platforms operated by us, our affiliates and/or other entities. We and/or they may use cookies or other technologies to track users online and to collect certain information which may include, but is not limited to, statistics about platform usage, IP addresses, browser and device type/s, Internet Service Provider, date/time stamp, number of clicks, and other information.\n      ")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n              How Do We Use Your Information? \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          We use information we receive from and about you and your account primarily to conduct business activities, including but not limited to: \n      ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n              Billing and collections\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n              Installation, operation and maintenance of our Services\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n              Confirmation that you are receiving (or have received) Services for which you have been billed\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n              Making programming recommendations \n          ")]),_vm._v(" "),_c('li',[_vm._v("\n              Marketing our Services, and those of our business partners,\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n              Detection of unauthorized users\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n              Determination of whether terms of use are being violated,\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n                  Configuration of Service-related devices\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n                  Statistical, quantitative and qualitative analysis\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n                  Compliance with applicable laws\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n                  Any other activities we reasonably deem necessary to provide our Services\n          ")])]),_vm._v(" "),_c('p',[_vm._v("\n              We are free to use the information collected (including PII) to improve, measure and/or analyze our Services, to provide more relevant marketing, and for analytical and/or reporting purposes. \n              We may also combine your information, including PII, with that received from third party sources, without restriction. \n              \n      ")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n              What Information of Yours Do We Disclose to Others?\n\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              SDG treats information about you (including PII) as confidential. However we cannot guarantee that these efforts and practices will prevent every unauthorized attempt to access, use, or disclose your information, including PII. In the normal course of business, we may also disclose or share your information, including PII, with other entities which provide services to SDG, including but not limited to billing and collections, administration, marketing, administration, maintenance and operations, and fraud prevention. We will use reasonable precautions in order to limit such disclosure/s to responsible parties. We may share such information with government agencies, if required by law or valid court order. We may also share such information with third parties that provide content, services or technologies used in, with, or in support of our Services. \n      ")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n          How Your Information May Be Used for Advertising Purposes\n\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          We may use your information (including but not limited to demographics, past purchases, and program viewing data) to provide you with advertising from us and our advertising partners. We may also use combine your information with other aggregated, de-identified information to create groups based on actual or assumed shared interests in order to target relevant advertising.\n      ")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n              What Choices Do You Have?\n   \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          You can adjust your device or browser to limit tracking or decline cookies, but this may limit our ability to provide you with our Services. We apologize for any inconvenience this may cause, and we regret that we do not currently have the capability to provide an alternate Services path for you. \n      ")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n              Enhanced Privacy Rights If You Are A Resident of California\n   \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              California law permits California residents to request certain details regarding how their PII is shared with third parties for direct marketing purposes. If you are a California resident and would like to make such a request, please contact us at the address shown below. You must clearly include “Your California Privacy Rights” on the request letter, the signature for which must also be notarized by a California licensed notary public. We are not responsible for any notices which are not properly labeled or sent, or do not have complete information and/or notarization. Please include a stamped, self-addressed envelope with your request. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          Mailing address: \n      ")]),_vm._v(" "),_c('p',[_vm._v("SDG Releasing")]),_vm._v(" "),_c('p',[_vm._v("135 East Olive Ave.")]),_vm._v(" "),_c('p',[_vm._v("#191")]),_vm._v(" "),_c('p',[_vm._v("Burbank, CA 91502")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n          Protecting Your PII     \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          We use commercially reasonable efforts to prevent third party access to your information, including PII. We may also maintain information about you for a period not to exceed seven years after your last purchase and/or use of Services, partly (but not exclusively) in order to comply with governmental audit requirements.\n      ")]),_vm._v(" "),_c('p',{staticClass:"titleBold"},[_vm._v("\n          Modification of Privacy Policy     \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          We may modify this notice at any time. Unless required by law, given the transactional nature of our TVOD Services, we will not notify you unless required by law. You may, however, access a copy the current version at any time on our website.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(348);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d1ddade_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(506);
function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d1ddade_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/16.b11835a5010863ade4ad.js